import {translater} from './translate'

export default {

	parseToCurrentLanguage : (feedback) => {

		let currentLanguage = 'en';
		if(window.localStorage.getItem('lang'))
		{
			currentLanguage = window.localStorage.getItem('lang');
		}


		feedback = feedback.map((f) => {
			
			
			f = parseDisplayName(f, currentLanguage)
			f = parseCheckPoint(f, currentLanguage)
			f = parseSubtask(f, currentLanguage)
			return f;
		})
		//console.log("###### parseToCurrentLanguage", feedback)
		return feedback;

	}
}

const parseDisplayName = (f, currentLanguage) => {



	let displayName = f.route.displayName;
	if(typeof displayName === 'string')
	{
		
		f.route.displayName = {};

		f.route.displayName[currentLanguage] = displayName;

	} else if(typeof displayName === 'object')
	{
		
		if(typeof displayName[currentLanguage] === 'undefined')
		{
			
			f.route.displayName[currentLanguage] = displayName[Object.keys(displayName)[0]];
			
		}


	}

	return f;			

}

const parseCheckPoint = (f, currentLanguage) => {

	let name = f.checkpoint.properties.name;
	//console.log("##############name", name)
	if(typeof name === 'string')
	{
		
		f.checkpoint.properties.name = {};

		f.checkpoint.properties.name[currentLanguage] = name;

	} else if(typeof name === 'object')
	{
		
		if(typeof name[currentLanguage] === 'undefined')
		{
			
			f.checkpoint.properties.name[currentLanguage] = name[Object.keys(name)[0]];
		}


	}

	return f;
}

const parseSubtask = (f, currentLanguage) => {
	let description = f.subtask.question.description;
	if(typeof description === 'string')
	{
		f.subtask.question.description = {};
		f.subtask.question.description[currentLanguage] = description;
	} else if(typeof description === 'object')
	{
		if(typeof description[currentLanguage] === 'undefined')
		{
			f.subtask.question.description[currentLanguage] = description[Object.keys(description)[0]];
			
		}
	} else if(typeof description === 'undefined')
	{
		f.subtask.question.description = {};
		f.subtask.question.description[currentLanguage] = f.checkpoint.properties.isFinish ? 
		translater.__('How did you find this route') : ''
	}

	return f;
}